import { render, staticRenderFns } from "./editProductGroupModal.vue?vue&type=template&id=357da3d6&"
import script from "./editProductGroupModal.vue?vue&type=script&lang=js&"
export * from "./editProductGroupModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports